// extracted by mini-css-extract-plugin
module.exports = {"actions":"invoice-actions_actions__2ETXI"};